import { InfoRow } from "@/shared/components/ui/InfoRow";
import { StatusBadge } from "@/shared/components/ui/StatusBadge";
import { formatBusinessTime } from "@/shared/utils/formatters";
import type { CalendarEvent } from "../types/calendarEventTypes";
import { eventDaySegment } from "../utils/agenda";

interface CalendarEventCardProps {
  event: CalendarEvent;
  dateKey: string;
  timezone: string;
  onClick: (event: CalendarEvent) => void;
}

export function CalendarEventCard({ event, dateKey, timezone, onClick }: CalendarEventCardProps) {
  const segment = eventDaySegment(event, dateKey, timezone);
  const time = (date: Date) => formatBusinessTime(date, timezone);
  const timing = event.isAllDay ? "All day"
    : `${segment.continuesBefore ? "Continued" : time(segment.startAt)} – ${segment.continuesAfter ? "continues tomorrow" : time(segment.endAt)}`;
  return (
    <InfoRow
      title={event.title || (event.kind === "blocked" ? "Blocked time" : "Personal event")}
      subtitle={`${event.kind === "blocked" ? "Blocked time" : "Personal event"} · Applies to all locations`}
      caption={[timing, event.isAllDay && segment.continuesBefore ? "Continued from previous day" : null, event.isAllDay && segment.continuesAfter ? "Continues tomorrow" : null].filter(Boolean).join(" · ")}
      icon={<span className="rounded-xl bg-matcha px-2 py-3 text-xs font-bold text-primary">{event.isAllDay ? "All day" : time(segment.startAt)}</span>}
      trailing={<StatusBadge tone={event.blocksAvailability ? "neutral" : "positive"}>{event.blocksAvailability ? "Busy" : "Free"}</StatusBadge>}
      onClick={() => onClick(event)}
      bold
      className="rounded-2xl border border-border bg-card"
    />
  );
}
